type GetTimeFromSearchConversationStart = (startTime: number | undefined) => number;
export const getTimeFromSearchConversationStart: GetTimeFromSearchConversationStart = (startTime) =>
  startTime ? Date.now() - startTime : -1;
